"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LibI18n = void 0;
const i18n_js_1 = __importDefault(require("i18n-js"));
const moment_1 = __importDefault(require("moment"));
const moment_timezone_1 = __importDefault(require("moment-timezone"));
const Language_1 = __importStar(require("./Language"));
// Fallback to english if translations are missing
Object.values(Language_1.default).forEach(l => {
    i18n_js_1.default.locales[(0, Language_1.languageLocale)(l)] = [(0, Language_1.languageCode)(l), 'en'];
});
class LibI18n {
    constructor() {
        this.loader = () => __awaiter(this, void 0, void 0, function* () { return undefined; });
    }
    t(key, replacements) {
        return i18n_js_1.default.t(key, replacements) || '';
    }
    lc(key, replacements) {
        var _a;
        return ((_a = this.t(key, replacements)) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || '';
    }
    uc(key, replacements) {
        var _a;
        return ((_a = this.t(key, replacements)) === null || _a === void 0 ? void 0 : _a.toUpperCase()) || '';
    }
    load(language, pkg) {
        i18n_js_1.default.translations[(0, Language_1.languageCode)(language)] = pkg;
    }
    alreadyLoaded(language) {
        return !!i18n_js_1.default.translations[(0, Language_1.languageCode)(language)];
    }
    switch(language) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loader(language);
            this._language = language;
            this._title = (0, Language_1.languageLabel)(language);
            this._locale = (0, Language_1.languageLocale)(language);
            this._countryCode = (0, Language_1.countryCode)(language);
            i18n_js_1.default.locale = this._locale;
            moment_1.default.locale(this._locale);
            moment_timezone_1.default.locale(this._locale);
        });
    }
    static instance() {
        if (!LibI18n._instance)
            LibI18n._instance = new LibI18n();
        LibI18n._instance.switch(Language_1.default.ENGLISH).catch(() => undefined);
        return LibI18n._instance;
    }
}
exports.LibI18n = LibI18n;
exports.default = LibI18n;
